export default __webpack_public_path__ + "static/media/homeBg.f3ddde71.jpg";